module.exports = __webpack_public_path__ + "static/Fortinet_Logo_Black-Red-7d7233867a78fafd80177a7908f526f2.png";